class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => this.onChange(event), 300).bind(this));
    }
  }
  toggleResetButton() {
    if (!this.resetButton || !this.input) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) this.resetButton.classList.remove('hidden');
    else if (this.input.value.length === 0 && !resetIsHidden) this.resetButton.classList.add('hidden');
  }
  onChange() { this.toggleResetButton(); }
  shouldResetForm() { return !document.querySelector('[aria-selected="true"] a'); }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define('search-form', SearchForm);

/* H1 Sticky ATC start */
(() => {
  const BAR_ID = 'jelado-sticky-atc';
  const STYLE_ID = 'jelado-sticky-atc-style';
  const cleanText = (text) => String(text || '').replace(/\s+/g, ' ').trim();

  function getProductInfo() {
    const form = document.querySelector('product-info form[action*="/cart/add"]');
    return form ? form.closest('product-info') : null;
  }

  function getMainSubmit(productInfo = getProductInfo()) {
    if (!productInfo) return null;
    return productInfo.querySelector('product-form button[name="add"], button[id^="ProductSubmitButton-"], form[action*="/cart/add"] button[type="submit"]');
  }

  function isElementVisibleInViewport(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function getTitle(productInfo = getProductInfo()) {
    const titleNode = productInfo?.querySelector('.product__title h1') || document.querySelector('main h1');
    return cleanText(titleNode?.textContent || document.title.split('–')[0] || '');
  }

  function getPrice(productInfo = getProductInfo()) {
    const priceRoot = productInfo?.querySelector('[id^="price-"]');
    if (!priceRoot) return '';
    const nodes = Array.from(priceRoot.querySelectorAll('.price-item--sale, .price-item--regular, .price__regular .price-item, .price__sale .price-item')).filter((node) => {
      if (node.closest('.visually-hidden')) return false;
      const style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    return nodes.map((node) => cleanText(node.textContent)).find(Boolean) || cleanText(priceRoot.textContent).replace(/通常価格|セール価格|単価|あたり|売り切れ/g, '').trim();
  }

  function getVariantSelects(productInfo = getProductInfo()) { return productInfo?.querySelector('variant-selects'); }

  function getSelectedOptions(productInfo = getProductInfo()) {
    const variantSelects = getVariantSelects(productInfo);
    if (!variantSelects) return '';
    const values = [];
    variantSelects.querySelectorAll('select').forEach((select) => { if (select.value) values.push(select.value); });
    variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked?.value) values.push(checked.value);
    });
    return values.filter(Boolean).join(' / ');
  }

  function findOptionSources(productInfo = getProductInfo()) {
    const variantSelects = getVariantSelects(productInfo);
    if (!variantSelects) return [];
    const sources = [];
    variantSelects.querySelectorAll('.product-form__input--dropdown select, select').forEach((select) => {
      const wrapper = select.closest('.product-form__input');
      const label = wrapper?.querySelector('label') || document.querySelector(`label[for="${select.id}"]`);
      sources.push({ type: 'select', name: cleanText(label?.textContent || select.name || ''), element: select });
    });
    variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;
      sources.push({ type: 'radio', name: cleanText(fieldset.querySelector('legend')?.textContent || inputs[0].name || ''), element: fieldset, inputs });
    });
    return sources;
  }

  function findSizeSource(productInfo = getProductInfo()) {
    const sources = findOptionSources(productInfo);
    if (!sources.length) return null;
    return sources.find((source) => /size|サイズ|waist|inseam|length/i.test(source.name)) || sources.find((source) => source.type === 'radio') || sources[0];
  }

  function isSourceOptionDisabled(optionElement) {
    return optionElement.disabled || optionElement.classList?.contains('disabled') || optionElement.classList?.contains('visually-disabled') || optionElement.getAttribute?.('aria-disabled') === 'true';
  }

  function populateStickySelector(bar, productInfo = getProductInfo()) {
    const select = bar.querySelector('[data-sticky-atc-size]');
    const source = findSizeSource(productInfo);
    if (!select || !source) { if (select) select.hidden = true; return; }
    select.hidden = false;
    select.setAttribute('aria-label', source.name || 'Option');
    select.innerHTML = '';
    if (source.type === 'select') {
      Array.from(source.element.options).forEach((option) => {
        const stickyOption = document.createElement('option');
        stickyOption.value = option.value;
        stickyOption.textContent = cleanText(option.textContent || option.value);
        stickyOption.disabled = option.disabled;
        stickyOption.selected = option.selected;
        select.appendChild(stickyOption);
      });
      return;
    }
    source.inputs.forEach((input) => {
      const stickyOption = document.createElement('option');
      stickyOption.value = input.value;
      stickyOption.textContent = input.value;
      stickyOption.disabled = isSourceOptionDisabled(input);
      stickyOption.selected = input.checked;
      select.appendChild(stickyOption);
    });
  }

  function setStickySelection(value) {
    const source = findSizeSource();
    if (!source) return;
    if (source.type === 'select') {
      source.element.value = value;
      source.element.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const targetInput = source.inputs.find((input) => input.value === value);
    if (targetInput && !isSourceOptionDisabled(targetInput)) {
      targetInput.click();
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${BAR_ID} {
        position: fixed; right: 0; bottom: 0; left: 0; z-index: 40;
        transform: translateY(110%); opacity: 0; pointer-events: none;
        transition: transform 180ms ease, opacity 180ms ease;
        padding: 1rem 1.5rem calc(1rem + env(safe-area-inset-bottom));
        background: rgb(var(--color-background));
        border-top: 0.1rem solid rgba(var(--color-foreground), 0.12);
        box-shadow: 0 -0.8rem 2.4rem rgba(0, 0, 0, 0.12);
      }
      #${BAR_ID}.is-visible { transform: translateY(0); opacity: 1; pointer-events: auto; }
      #${BAR_ID} .sticky-atc__inner {
        width: min(100%, 92rem);
        margin: 0 auto;
        display: grid;
        grid-template-columns: minmax(0, 1fr) 44rem;
        gap: 2.4rem;
        align-items: center;
      }
      #${BAR_ID} .sticky-atc__info { min-width: 0; }
      #${BAR_ID} .sticky-atc__title {
        margin: 0; max-width: 100%; font-size: 1.3rem; line-height: 1.3;
        color: rgb(var(--color-foreground)); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      }
      #${BAR_ID} .sticky-atc__meta {
        margin-top: 0.2rem; display: flex; gap: 0.8rem; flex-wrap: nowrap; min-width: 0;
        font-size: 1.2rem; line-height: 1.3; color: rgba(var(--color-foreground), 0.7); overflow: hidden;
      }
      #${BAR_ID} .sticky-atc__meta span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
      #${BAR_ID} .sticky-atc__row {
        display: grid;
        grid-template-columns: 14rem 28rem;
        gap: 0.8rem;
        justify-content: end;
      }
      #${BAR_ID} .sticky-atc__select {
        -webkit-appearance: none; appearance: none; box-sizing: border-box; width: 100%; height: 4.4rem; min-height: 4.4rem;
        padding: 0 2.4rem; border: 0.1rem solid rgba(var(--color-foreground), 0.2); border-radius: var(--inputs-radius);
        background-color: rgb(var(--color-background)); color: rgb(var(--color-foreground)); font: inherit; font-size: 1.4rem;
        line-height: 4.4rem; text-align: center; text-align-last: center; cursor: pointer;
      }
      #${BAR_ID} .sticky-atc__button {
        min-height: 4.4rem; width: 100%; padding: 0 2.4rem; border: 0; border-radius: var(--buttons-radius-outset);
        background: rgba(var(--color-button), var(--alpha-button-background)); color: rgb(var(--color-button-text));
        font: inherit; font-size: 1.4rem; letter-spacing: 0.08rem; cursor: pointer; white-space: nowrap;
      }
      #${BAR_ID} .sticky-atc__button[disabled] { cursor: not-allowed; opacity: 0.5; }
      @media screen and (min-width: 990px) {
        #${BAR_ID} .sticky-atc__inner { width: min(100%, 88rem); grid-template-columns: minmax(0, 38rem) 44rem; gap: 2rem; }
      }
      @media screen and (max-width: 749px) {
        #${BAR_ID} { padding-right: 1rem; padding-left: 1rem; }
        #${BAR_ID} .sticky-atc__inner { width: min(100%, var(--page-width)); grid-template-columns: 1fr; gap: 0.8rem; }
        #${BAR_ID} .sticky-atc__row { grid-template-columns: minmax(9rem, 38%) 1fr; justify-content: stretch; }
        #${BAR_ID} .sticky-atc__title { font-size: 1.2rem; }
        #${BAR_ID} .sticky-atc__meta { font-size: 1.1rem; }
        #${BAR_ID} .sticky-atc__select { height: 4.6rem; min-height: 4.6rem; line-height: 4.6rem; padding-right: 2.2rem; padding-left: 2.2rem; }
      }
    `;
    document.head.appendChild(style);
  }

  function createStickyBar() {
    const existing = document.getElementById(BAR_ID);
    if (existing) return existing;
    const bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'カート追加固定バー');
    bar.innerHTML = `<div class="sticky-atc__inner"><div class="sticky-atc__info"><p class="sticky-atc__title" data-sticky-atc-title></p><div class="sticky-atc__meta"><span data-sticky-atc-price></span><span data-sticky-atc-options></span></div></div><div class="sticky-atc__row"><select class="sticky-atc__select" data-sticky-atc-size></select><button type="button" class="sticky-atc__button" data-sticky-atc-button></button></div></div>`;
    bar.querySelector('[data-sticky-atc-size]').addEventListener('change', (event) => { setStickySelection(event.target.value); setTimeout(() => updateStickyBar(bar), 160); });
    bar.querySelector('[data-sticky-atc-button]').addEventListener('click', () => {
      const submit = getMainSubmit();
      if (submit && !submit.disabled && !submit.hasAttribute('disabled')) submit.click();
    });
    document.body.appendChild(bar);
    return bar;
  }

  function updateVisibility(bar) {
    if (!bar) return;
    const productInfo = getProductInfo();
    const submit = getMainSubmit(productInfo);
    const mainSubmitVisible = isElementVisibleInViewport(submit);
    const shouldShow = !!productInfo && !!submit && window.scrollY > 20 && !mainSubmitVisible;
    bar.classList.toggle('is-visible', shouldShow);
    document.documentElement.classList.toggle('sticky-atc-visible', shouldShow);
  }

  function updateStickyBar(bar) {
    const productInfo = getProductInfo();
    const submit = getMainSubmit(productInfo);
    if (!productInfo || !submit) { bar?.remove(); document.documentElement.classList.remove('sticky-atc-visible'); return; }
    bar.querySelector('[data-sticky-atc-title]').textContent = getTitle(productInfo);
    bar.querySelector('[data-sticky-atc-price]').textContent = getPrice(productInfo);
    bar.querySelector('[data-sticky-atc-options]').textContent = getSelectedOptions(productInfo);
    populateStickySelector(bar, productInfo);
    const button = bar.querySelector('[data-sticky-atc-button]');
    const isDisabled = submit.disabled || submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true';
    const buttonText = cleanText(submit.querySelector('span')?.textContent || submit.textContent || window.variantStrings?.addToCart || 'カートに追加する');
    button.disabled = isDisabled;
    button.textContent = buttonText;
    updateVisibility(bar);
  }

  function initStickyATC() {
    if (window.__jeladoStickyATCInitialized) return;
    const productInfo = getProductInfo();
    if (!productInfo || !getMainSubmit(productInfo)) return;
    window.__jeladoStickyATCInitialized = true;
    injectStyles();
    const bar = createStickyBar();
    updateStickyBar(bar);
    ['scroll', 'resize'].forEach((eventName) => window.addEventListener(eventName, () => updateVisibility(bar), { passive: true }));
    document.addEventListener('change', () => setTimeout(() => updateStickyBar(bar), 160));
    if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => setTimeout(() => updateStickyBar(bar), 160));
    const observer = new MutationObserver((mutations) => {
      if (mutations.every((mutation) => mutation.target?.closest?.(`#${BAR_ID}`))) return;
      setTimeout(() => updateStickyBar(bar), 160);
    });
    observer.observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyATC);
  else initStickyATC();
  document.addEventListener('shopify:section:load', initStickyATC);
})();
/* H1 Sticky ATC end */

/* H3 Coming Soon card badge start */
(() => {
  if (window.__jeladoComingSoonCardBadgeInitialized) return;
  window.__jeladoComingSoonCardBadgeInitialized = true;
  const BADGE_CLASS = 'jelado-card-coming-soon-badge';
  const STYLE_ID = 'jelado-card-coming-soon-badge-style';
  const CACHE_PREFIX = 'jelado-coming-soon-card:';
  function injectComingSoonBadgeStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `.${BADGE_CLASS}{display:inline-block;padding:.5rem 1rem;border:.1rem solid rgba(var(--color-foreground),.3);background:rgb(var(--color-background));color:rgb(var(--color-foreground));font-size:1.1rem;line-height:1;letter-spacing:.14rem;text-transform:uppercase;}`;
    document.head.appendChild(style);
  }
  function normalizeProductUrl(url) {
    try { const parsed = new URL(url, window.location.origin); parsed.search = ''; parsed.hash = ''; return parsed.pathname; } catch (error) { return ''; }
  }
  function findProductCards() {
    return Array.from(document.querySelectorAll('.product-card-wrapper')).map((wrapper) => {
      const link = wrapper.querySelector('a[href*="/products/"]');
      const badgeContainer = wrapper.querySelector('.card__content > .card__badge') || wrapper.querySelector('.card__badge');
      return { wrapper, link, badgeContainer };
    }).filter((item) => item.link && item.badgeContainer);
  }
  function getCached(cacheKey) { try { return sessionStorage.getItem(cacheKey); } catch (error) { return null; } }
  function setCached(cacheKey, value) { try { sessionStorage.setItem(cacheKey, value); } catch (error) {} }
  async function isComingSoonProduct(pathname) {
    if (!pathname) return false;
    const cacheKey = CACHE_PREFIX + pathname;
    const cached = getCached(cacheKey);
    if (cached === '1') return true;
    if (cached === '0') return false;
    try {
      const response = await fetch(pathname, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Failed to fetch product page');
      const html = await response.text();
      const isComingSoon = /jelado-coming-soon-cta/i.test(html || '');
      setCached(cacheKey, isComingSoon ? '1' : '0');
      return isComingSoon;
    } catch (error) { return false; }
  }
  function addComingSoonBadge(item) {
    if (!item?.badgeContainer || item.badgeContainer.querySelector(`.${BADGE_CLASS}`)) return;
    item.badgeContainer.innerHTML = '';
    const badge = document.createElement('span');
    badge.className = `${BADGE_CLASS} badge badge--bottom-left`;
    badge.textContent = 'COMING SOON';
    item.badgeContainer.appendChild(badge);
  }
  async function initComingSoonCardBadges() {
    injectComingSoonBadgeStyles();
    const cards = findProductCards();
    await Promise.all(cards.map(async (item) => {
      if (item.wrapper.dataset.jeladoComingSoonChecked === 'true') return;
      item.wrapper.dataset.jeladoComingSoonChecked = 'true';
      if (await isComingSoonProduct(normalizeProductUrl(item.link.getAttribute('href')))) addComingSoonBadge(item);
    }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initComingSoonCardBadges);
  else initComingSoonCardBadges();
  window.addEventListener('load', initComingSoonCardBadges);
  document.addEventListener('shopify:section:load', initComingSoonCardBadges);
})();
/* H3 Coming Soon card badge end */

/* H5 JP EN language toggle start */
(() => {
  if (window.__jeladoLanguageToggleInitialized) return;
  window.__jeladoLanguageToggleInitialized = true;

  const TOGGLE_CLASS = 'jelado-language-toggle';
  const STYLE_ID = 'jelado-language-toggle-style';
  const JAPAN_HOST = 'jelado.com';
  const ENGLISH_HOST = 'en.jelado.com';

  function injectLanguageToggleStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${TOGGLE_CLASS} {
        display: inline-flex;
        align-items: center;
        gap: .45rem;
        margin-left: 1.2rem;
        font-size: 1.2rem;
        line-height: 1;
        letter-spacing: .08rem;
        text-transform: uppercase;
        color: rgba(var(--color-foreground), .55);
        white-space: nowrap;
      }
      .${TOGGLE_CLASS} a {
        color: rgba(var(--color-foreground), .55);
        text-decoration: none;
      }
      .${TOGGLE_CLASS} a[aria-current="true"] {
        color: rgb(var(--color-foreground));
        font-weight: 600;
      }
      .${TOGGLE_CLASS}__divider { color: rgba(var(--color-foreground), .35); }
      @media screen and (max-width: 749px) {
        .${TOGGLE_CLASS} { margin-left: .6rem; font-size: 1.1rem; gap: .35rem; }
      }
    `;
    document.head.appendChild(style);
  }

  function removeJapaneseSubfolder(pathname) {
    if (pathname === '/ja') return '/';
    if (pathname.startsWith('/ja/')) return pathname.replace(/^\/ja/, '') || '/';
    return pathname || '/';
  }

  function buildLocaleUrl(targetLocale) {
    const current = new URL(window.location.href);
    let pathname = removeJapaneseSubfolder(current.pathname || '/');
    const query = current.search || '';
    const hash = current.hash || '';
    if (targetLocale === 'en') return `https://${ENGLISH_HOST}${pathname}${query}${hash}`;
    return `https://${JAPAN_HOST}${pathname}${query}${hash}`;
  }

  function isEnglishContext() {
    return window.location.hostname === ENGLISH_HOST && !(window.location.pathname === '/ja' || window.location.pathname.startsWith('/ja/'));
  }

  function createLanguageToggle() {
    const nav = document.createElement('nav');
    nav.className = TOGGLE_CLASS;
    nav.setAttribute('aria-label', 'Language');
    const isEn = isEnglishContext();
    nav.innerHTML = `<a href="${buildLocaleUrl('ja')}" aria-current="${isEn ? 'false' : 'true'}">JP</a><span class="${TOGGLE_CLASS}__divider" aria-hidden="true">/</span><a href="${buildLocaleUrl('en')}" aria-current="${isEn ? 'true' : 'false'}">EN</a>`;
    return nav;
  }

  function findHeaderTarget() {
    return document.querySelector('.header__icons') || document.querySelector('header .header__icon--cart')?.parentElement || document.querySelector('header');
  }

  function initLanguageToggle() {
    injectLanguageToggleStyles();
    const target = findHeaderTarget();
    if (!target || target.querySelector(`.${TOGGLE_CLASS}`)) return;
    const toggle = createLanguageToggle();
    const cartIcon = target.querySelector('.header__icon--cart');
    if (cartIcon) target.insertBefore(toggle, cartIcon);
    else target.appendChild(toggle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLanguageToggle);
  else initLanguageToggle();
  document.addEventListener('shopify:section:load', initLanguageToggle);
})();
/* H5 JP EN language toggle end */

/* H8 international selector UX start */
(() => {
  if (window.__jeladoInternationalSelectorUxInitialized) return;
  window.__jeladoInternationalSelectorUxInitialized = true;

  const WRAP_CLASS = 'jelado-international-selector-ux';
  const STYLE_ID = 'jelado-international-selector-ux-style';

  function injectInternationalSelectorStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${WRAP_CLASS} {
        width: 100%;
        max-width: 46rem;
        margin: 0 0 1.4rem;
        padding: 1.4rem 1.6rem;
        border: .1rem solid rgba(var(--color-foreground), .14);
        background: rgba(var(--color-foreground), .025);
        text-align: left;
      }
      .${WRAP_CLASS}__heading {
        margin: 0 0 .45rem;
        color: rgb(var(--color-foreground));
        font-size: 1.3rem;
        line-height: 1.4;
        font-weight: 600;
        letter-spacing: .06rem;
      }
      .${WRAP_CLASS}__text {
        margin: 0 0 .8rem;
        color: rgba(var(--color-foreground), .72);
        font-size: 1.2rem;
        line-height: 1.6;
      }
      .${WRAP_CLASS}__link {
        font-size: 1.2rem;
        line-height: 1.4;
      }
      @media screen and (max-width: 749px) {
        .${WRAP_CLASS} {
          max-width: none;
          margin-top: 1.2rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function createInternationalSelectorIntro() {
    const box = document.createElement('div');
    box.className = WRAP_CLASS;
    box.innerHTML = `
      <p class="${WRAP_CLASS}__heading">Shipping destination &amp; language</p>
      <p class="${WRAP_CLASS}__text">Choose your shipping destination and language before checkout.</p>
      <a class="${WRAP_CLASS}__link link underlined-link" href="/pages/international-shipping-duties">International Shipping &amp; Duties</a>
    `;
    return box;
  }

  function initInternationalSelectorUx() {
    injectInternationalSelectorStyles();
    const footerLocalization = document.querySelector('.footer__column.footer__localization');
    if (!footerLocalization || footerLocalization.querySelector(`.${WRAP_CLASS}`)) return;
    footerLocalization.insertBefore(createInternationalSelectorIntro(), footerLocalization.firstChild);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initInternationalSelectorUx);
  else initInternationalSelectorUx();
  window.addEventListener('load', initInternationalSelectorUx);
  document.addEventListener('shopify:section:load', initInternationalSelectorUx);
})();
/* H8 international selector UX end */
